import React from "react";

interface LoadingSpinnerProps {
  size?: number;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 32,
  className = "",
}) => {
  return (
    <div
      className={`animate-spin rounded-full border-2 border-white border-t-transparent ${className}`}
      style={{ width: size, height: size }}
    />
  );
};
